var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "4px",
    viewBox: "0 0 16 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/16px/More") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 C3.1045695,0 4,0.8954305 4,2 C4,3.1045695 3.1045695,4 2,4 C0.8954305,4 0,3.1045695 0,2 C0,0.8954305 0.8954305,0 2,0 Z M8,0 C9.1045695,0 10,0.8954305 10,2 C10,3.1045695 9.1045695,4 8,4 C6.8954305,4 6,3.1045695 6,2 C6,0.8954305 6.8954305,0 8,0 Z M14,0 C15.1045695,0 16,0.8954305 16,2 C16,3.1045695 15.1045695,4 14,4 C12.8954305,4 12,3.1045695 12,2 C12,0.8954305 12.8954305,0 14,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-in-progress",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comments-Alt/1",
    transform: "translate(-1378.000000, -104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comment-Sidebar",
    transform: "translate(1140.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comment-Header",
    transform: "translate(1.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/More",
    transform: "translate(237.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2699\\uFE0FAtoms/Colour/Grey",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2699\\uFE0FAtoms/Colour/Grey/Medium",
    mask: "url(#mask-2)",
    fill: "#8A8E96"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -6.000000)",
    id: "Colour"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.5743af9c703e2bd2c8167550a41a673f.svg";
export { ForwardRef as ReactComponent };